var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.valores_entradas_vendidas_grafica)?_c('GChart',{attrs:{"type":"PieChart","data":_vm.valores_entradas_vendidas_grafica,"options":_vm.chartOptions}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }